// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function execute(current_fare_details, duration_selector) {
  return {
          crn: current_fare_details.data.crn,
          start_time: Timestamp$Catalyst.toFloat(current_fare_details.data.start_time),
          end_time: Timestamp$Catalyst.toFloat(current_fare_details.data.end_time),
          waiting_time: current_fare_details.data.order_fare.waiting_time,
          restricted_time: current_fare_details.data.order_fare.total_restricted_time_mins,
          toll: Currency.fromCurrency(current_fare_details.data.order_fare.toll),
          travel_distance: current_fare_details.data.order_fare.travel_distance,
          is_return_trip: current_fare_details.data.is_return_trip,
          road_tax: Currency.fromCurrency(current_fare_details.data.order_fare.road_tax),
          environmental_tax: undefined,
          up_entry_charge: Currency.fromCurrency(current_fare_details.data.order_fare.convenience_charge),
          incidental_charges: List.map((function (incident) {
                  return {
                          incidental_charge_id: incident.charge_type.id,
                          amount: Currency.fromCurrency(incident.amount)
                        };
                }), current_fare_details.data.order_fare.incidental_charges),
          has_waypoints: current_fare_details.data.has_waypoints,
          from_state_id: undefined,
          to_state_id: undefined,
          travel_duration: duration_selector ? undefined : current_fare_details.data.order_fare.travel_duration
        };
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
